import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, ViewController, AlertController } from 'ionic-angular';
import { ArticoliPage } from '../articoli/articoli';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import { SERVER_URL } from "../../config";
import { FileUploader } from 'ng2-file-upload';
import { Storage } from "@ionic/storage";

const URL = SERVER_URL + "/articoli/updateArticoloImg";

/**
 * Generated class for the EditarticoloPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-editarticolo',
  templateUrl: 'editarticolo.html',
})
export class EditarticoloPage {
  articolo;
  uploader: FileUploader;
  carpeta = "";
  indice = 0;
  jwt;
  errorMessage;
  categorie;
  link;
  constructor(public navCtrl: NavController, public navParams: NavParams,
    private readonly loadingCtrl: LoadingController, public rest: RestApiProvider, private viewCtrl: ViewController,
    private readonly storage: Storage,
    private alertCtrl: AlertController,

  ) {
    this.articolo = navParams.get('articolo');
    if (this.articolo.descrizione1!= null && this.articolo.descrizione1.length > 0) {
      this.articolo.descrizione = this.articolo.descrizione + this.articolo.descrizione1;
    }
    this.link = SERVER_URL + "/manifesti/files/"
    this.storage.get('jwt_token').then((value) => {
      this.jwt = value;
      console.log(" jwt_tokennnnnnnnnnnnn:" + this.jwt)

    })
  }

  openFileDialog1 = function () {
    document.getElementById('seleccion').click();
    this.filecreate();

    /*
     if (this.carpeta.length < 5) {
         alert("El nombre de carpeta no ha sido especificado o no se trata de un nombre valido.");
     } else {
         document.getElementById('seleccion').click();
     }
     */
  };
  filecreate() {
    // alert("filecreate")

    console.log("filecreate new Fileuploader:" + this.jwt)
    this.uploader = new FileUploader({
      authToken: 'Bearer ' + this.jwt,
      url: URL, // url del php que trata el fichero subido
      method: 'POST',
      removeAfterUpload: true, // lo quita de la lista una vez su subida fue correcta
      queueLimit: 100 // limite de archivos que se pueden añadir a la lista, si el numero de archivos seleccionados es superior se cogen los x primeros.
    });
    // alert("uploader:"+JSON.stringify(this.uploader))


    this.uploader.onBuildItemForm = (fileItem: any, form: any) => {
      console.log("uploader.onBuildItemForm")
      // alert('articoloString:'+ JSON.stringify(this.articolo))
      form.append('articoloString', JSON.stringify(this.articolo));

      form.append('id', this.indice);
      form.append('fotonum', 'n1');
      form.append('carpeta', this.carpeta);
      this.indice = this.indice + 1;
    };
    // Función que salta cada vez que añadimos un nuevo archivo, aqui podemos controlar que no se suban archivos demasiado grandes
    this.uploader.onAfterAddingFile = function (fileItem) {
      if (fileItem.file.size > 5242880) {
        alert("Il file non deve supere 5 MB");


        fileItem.cancel();
        fileItem.remove();
      }
      fileItem.withCredentials = false;
      console.info('onAfterAddingFile', fileItem);
    };
    // Función que salta cuando se han añadido todos los archivos seleccionados.
    this.uploader.onAfterAddingAll = function (addedFileItems) {
      console.info('onAfterAddingAll');
    };
    // Función que se ejecuta antes de subir un archivo. Aquí añadimos datos adicionales necesarios para renombrar el
    // archivo como nosotros queremos.
    this.uploader.onBeforeUploadItem = function (item) {

      console.info('onBeforeUploadItem');

    };
    // Barra de progreso que indica la subida.
    this.uploader.onProgressItem = function (fileItem, progress) {
      console.info('onProgressItem');
    };
    // Función que se ejecuta cuando la barra de progreso llega a su fin.
    this.uploader.onProgressAll = function (progress) {
      console.info('onProgressAll');
    };
    // Función que salta si la subida del archivo se produjo con éxito en nuestro caso guardamos los índices de las
    // imágenes para almacenarlos posteriormente en la bdd.
    this.uploader.onSuccessItem = function (fileItem, response, status, headers) {
      alert(response);

      console.info('onSuccessItem', fileItem, response, status, headers);

    };
    // Función que salta si se produce un error en la subida.
    this.uploader.onErrorItem = function (fileItem, response, status, headers) {
      alert(response);

      console.info('onErrorItem', fileItem, response, status, headers);
    };
    // Función que se ejecuta si se cancela la subida.
    this.uploader.onCancelItem = function (fileItem, response, status, headers) {
      console.info('onCancelItem', fileItem, response, status, headers);
    };

    this.uploader.onCompleteItem = function (fileItem, response, status, headers) {
      console.info('onCompleteItem');
    };
    this.uploader.onCompleteAll = function () {
      console.info('onCompleteAll');
    };

  }
  updateArticolo() {
    let loading = this.loadingCtrl.create({

      spinner: 'bubbles',
      duration: 4000,

      content: 'save articolo ...'

    });

    loading.present();
    console.log('updateArticolo this.articolo :' + this.articolo);

    console.log('updateArticolo this.articolo:' + JSON.stringify(this.articolo));

    if(this.articolo.descrizione!=null && this.articolo.descrizione.length>191){
      var descrizione=this.articolo.descrizione;
     // alert(descrizione)
      this.articolo.descrizione=descrizione.substring(0, 191);
      this.articolo.descrizione1=descrizione.substring(191, descrizione.length);

    }
   // alert(JSON.stringify(this.articolo));
    if (this.uploader == null || this.uploader.queue == null) {
      this.rest.aggiornaArticolo(this.articolo).subscribe(
        res =>{
          //alert(JSON.stringify(res))
           loading.dismiss();
          this.navCtrl.push(ArticoliPage, { categoria: this.articolo.categoria }).then(() => { this.navCtrl.remove(this.navCtrl.getActive().index - 2, 2); });

        },
        error => this.errorMessage = <any>error);

    }
    else if (this.uploader != null && this.uploader.queue != null) {
      this.uploader.queue[0].upload();
      let hideFooterTimeout1 = setTimeout(() => {
        // loading.dismiss();
        this.navCtrl.push(ArticoliPage, { categoria: this.articolo.categoria }).then(() => { this.navCtrl.remove(this.navCtrl.getActive().index - 2, 2); });
  
      }, 5000);
  
    }

  




    // this.navCtrl.push(ArticoliPage,{categoria: this.articolo.categoria});




  }
  changeCategoria(event) {

    // alert(this.articolo.categoria.name)
    this.showCategoria();
  }

  showCategoria() {
    let alert = this.alertCtrl.create({
      title: 'Categorie ',
      subTitle: "Seleziona la nuova categoria",
      enableBackdropDismiss: false, // <- Here! :)
      buttons: [
        {
          text: 'Annulla',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');



          }
        },
        {
          text: '  Cambia  ',
          handler: data => {

            console.log('OK clicked. Data -> ' + JSON.stringify(data));
            this.articolo.categoria = this.categorie[data];
          }
        }
      ]
    });
    var i;
    for (i = 0; i < this.categorie.length; i++) {
      if (this.articolo.categoria.id !== this.categorie[i].id) {
        alert.addInput({
          type: 'radio',
          label: this.categorie[i].name,
          checked: this.categorie[i].selezionato,
          value: i
        })

      }



    }

    alert.present();
  }

  getCategorie() {
    this.rest.getCategorie()
      .subscribe(
        categorie => this.categorie = categorie,
        error => this.errorMessage = <any>error);
  }
  ionViewDidLoad() {

    this.getCategorie();
    console.log('ionViewDidLoad EditarticoloPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/editarticolo/editarticolo.ts